import { useEffect, useRef } from "react";

const toRad = (deg) => (deg * Math.PI) / 180;

export function useDeviceTilt() {
    const angles = useRef({ pitch: 0, roll: 0 }); // radians

    useEffect(() => {
        const k = 0.5;
        const onOrient = (e) => {
            const pitch = toRad(e.beta ?? 0);  // avant/arrière
            const roll = toRad(e.gamma ?? 0);  // gauche/droite
            angles.current.pitch += (pitch - angles.current.pitch) * k;
            angles.current.roll += (roll - angles.current.roll) * k;
        };
        window.addEventListener("deviceorientation", onOrient, { passive: true });
        return () => window.removeEventListener("deviceorientation", onOrient);
    }, []);

    return () => angles.current; // getter
}


